import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Text, Grid } from '@chakra-ui/react';
import Container from 'components/common/Container';
import ImageBlog from 'components/common/ImageBlog';
import { getPopular as apiPopularPost } from 'services/blog';

const Popular = () => {
  const router = useRouter();
  const [popularData, setPopularData] = useState(null);

  useEffect(() => {
    apiPopularPost(router.locale).then((res) => {
      setPopularData(res.data);
    });
  }, [router.locale]);
  return (
    <>
      <Container>
        <Text as={'h1'} mb={'20px'} fontSize={'36px'} fontWeight={'400'} textAlign="center" paddingTop="80px">
          Τα πιο<strong> δημοφιλή</strong>
        </Text>
        <Grid templateColumns={{ base: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={6}>
          {popularData?.map(({ title, blogPath, categoryName, categoryPath, created, image }, index) => {
            return (
              <ImageBlog
                key={`ImageBlog-${index}`}
                title={title}
                blogPath={blogPath}
                categoryName={categoryName}
                categoryPath={categoryPath}
                created={created}
                image={image}
                popular={true}
                alt={title}
              />
            );
          })}
        </Grid>
      </Container>
    </>
  );
};

export default Popular;
